import { render, staticRenderFns } from "./MonthlyChartCard2.vue?vue&type=template&id=b5768148&scoped=true"
import script from "./MonthlyChartCard2.vue?vue&type=script&lang=js"
export * from "./MonthlyChartCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5768148",
  null
  
)

export default component.exports